import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { validateAdminRedirectPath } from "@/config/auth";
import {
  AdminSignInError,
  completeAdminSignIn,
  readGoogleCallback,
} from "@/core/auth/adminGoogleSignIn";
import { LoginPage, LoginPending } from "../components/LoginPage";

/**
 * Google's return from the admin sign-in redirect (spec 2026-10-15). The
 * token rides in the URL fragment, so the fragment is stripped before
 * anything else. A ref guards the one-shot work: StrictMode mounts effects
 * twice, and a second read would find the state already consumed.
 */
export const AdminGoogleCallbackRoute: React.FC = () => {
  const navigate = useNavigate();
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;

    const hash = window.location.hash;
    window.history.replaceState(window.history.state, "", window.location.pathname);
    const result = readGoogleCallback(hash);
    if (!result.ok) {
      navigate("/portal/login", { replace: true, state: { adminError: result.code } });
      return;
    }

    completeAdminSignIn(result.accessToken)
      .then(() => {
        navigate(validateAdminRedirectPath(result.redirect) ?? "/", { replace: true });
      })
      .catch((err: unknown) => {
        const code = err instanceof AdminSignInError ? err.code : "failed";
        navigate("/portal/login", { replace: true, state: { adminError: code } });
      });
  }, [navigate]);

  return (
    <LoginPage>
      <LoginPending label="Accesso in corso..." />
    </LoginPage>
  );
};
